import React, { useState } from "react";
import { X } from "lucide-react";

// Two-step confirm: request a code (mailed to the ADMIN's own inbox, not
// the target user's), then enter it to actually clear the target's PIN.
const ResetPinModal = ({ isOpen, onClose, onRequestCode, onConfirmCode, isRequesting, isConfirming }) => {
  const [step, setStep] = useState("confirm");
  const [code, setCode] = useState("");

  if (!isOpen) return null;

  const handleClose = () => {
    setStep("confirm");
    setCode("");
    onClose();
  };

  const handleRequest = async () => {
    await onRequestCode();
    setStep("enter-code");
  };

  const handleSubmitCode = async (e) => {
    e.preventDefault();
    await onConfirmCode(code);
    handleClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center w-full bg-black bg-opacity-50">
      <div className="relative p-6 w-full max-w-96 bg-white rounded-2xl">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <X size={20} />
        </button>

        {step === "confirm" && (
          <div className="flex flex-col items-center space-y-4 text-center">
            <label className="mb-2 font-sans text-lg font-semibold text-[#EB5757]">
              Reset user PIN
            </label>
            <p className="text-sm text-[#4F4F4F]">
              This clears the user's transaction PIN - they'll be asked to set a
              new one. We'll email a confirmation code to your own admin
              inbox before this takes effect.
            </p>
            <button
              onClick={handleRequest}
              disabled={isRequesting}
              className="self-center py-3 px-3 my-2 w-56 font-sans text-white bg-[#EB5757] rounded-full disabled:opacity-50"
            >
              {isRequesting ? "Sending code..." : "Send confirmation code"}
            </button>
          </div>
        )}

        {step === "enter-code" && (
          <form onSubmit={handleSubmitCode} className="flex flex-col items-center space-y-4 text-center">
            <label className="mb-2 font-sans text-lg font-semibold text-[#EB5757]">
              Enter confirmation code
            </label>
            <p className="text-sm text-[#4F4F4F]">
              Check your own admin email for the code we just sent.
            </p>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="6-digit code"
              maxLength={6}
              className="px-3 py-2 w-48 text-sm text-center rounded-lg border border-gray-200 outline-none focus:ring-2 focus:ring-emerald-500"
            />
            <button
              type="submit"
              disabled={isConfirming || code.length !== 6}
              className="self-center py-3 px-3 my-2 w-56 font-sans text-white bg-[#EB5757] rounded-full disabled:opacity-50"
            >
              {isConfirming ? "Confirming..." : "Confirm and reset PIN"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPinModal;
